import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const MoveIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "move",
  "MoveIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M5.99967 1H3.99707V3.0026H5.99967V1Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M11.9997 1H9.99707V3.0026H11.9997V1Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M5.99967 5H3.99707V7.0026H5.99967V5Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M11.9997 5H9.99707V7.0026H11.9997V5Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M5.99967 9H3.99707V11.0026H5.99967V9Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M11.9997 9H9.99707V11.0026H11.9997V9Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M5.99967 13H3.99707V15.0026H5.99967V13Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M11.9997 13H9.99707V15.0026H11.9997V13Z" fill={colorList[0]} fillOpacity="0.9"/></g></svg>
);

export default MoveIcon;
